<template>
  <div class="collectList">
    <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" class="lists">
      <li @click="gotodetail(item.id)"  v-for="item in collectionList" class="collectItem">
        <img :src="item.picUrl" alt="" /><span class="itemTime">{{item.year}}/{{item.dayMonth}}</span>
        <div class="itemRight">
          <p class="heardline">{{item.headline}}</p>
          <p class="indroduce">{{item.description}}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import {api} from '../global/api';
  import { Indicator } from 'mint-ui';
    export default {
        name: "newshot",
      data(){
        return {
          collectionList:[],
          loading:true,
          page:1,
          size:6
        }
      },
      mounted(){
        this.getCollections(true);
      },
      methods: {
        loadMore() {
          this.page ++;
          this.loading = true;
          this.getCollections(true);

         /* setTimeout(() => {
            this.page ++;
            this.getCollections(true);
          }, 1000);*/

          },
        gotodetail(id) {
          this.$router.push({
            path: 'hotDetail',
            query: {id: id}
          });
        },
        getCollections(flag) {
          let that = this;
          let params={uniqueName:'xwdt',currentPage:this.page,size:this.size};
          Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
          this.$http.get(api.getArticleListByUniqueType, {params:params}).then(response => {
            console.log("请求成功了1");
            if(response.data.success==1){
              Indicator.close();
              if(flag){
                that.collectionList = that.collectionList.concat(response.data.data);
                if(response.data.data.length == 0){
                  this.loading = true;
                }else{
                  this.loading = false;
                }
              }else{
                this.collectionList = response.data.data;
                this.loading = false;
              }
            }else{
              console.log("接口异常");
            }
            // console.log(that.showingDates);
          }, response => {
            console.log("请求失败了");
          })
        },
      }
    }
</script>

<style scoped>
  .collectList{
    padding: 0rem .8rem 2.45rem;
  }
  .lists{
    margin: 0;
  }
   .collectItem{
     width: 17.25rem;
     height: 5.1rem;
     position: relative;
     padding: 0;
     margin:0 0 .5rem;
   }
  .collectItem img{
    display: inline-block;
    width: 6.8rem;
    height: 5.1rem;
    border-radius: .4rem;
    display: block;
    float: left;
  }
  .itemRight{
    width:  9.45rem;
    height: 3.2rem;
    border-top-right-radius: .4rem;
    border-bottom-right-radius: .4rem;
    background-color: rgba(241, 241, 242, 1);
    display: inline-block;
    padding: .65rem .5rem;
    vertical-align: bottom;
    float: left;
    margin-top: .6rem;
  }
  .heardline{
    width: 100%;
    height: 0.7rem;
    line-height: 0.7rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFang-SC-Medium;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .indroduce{
    width: 100%;
    height: 1.85rem;
    line-height: 0.9rem;
    color: rgba(153, 153, 153, 1);
    font-size: 0.65rem;
    text-align: left;
    font-family: PingFang-SC-Regular;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    margin-top: .35rem;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */

  }
  .itemTime{
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    margin: auto;
    width: 4.65rem;
    display: block;
    height: 1rem;
    line-height: 1rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.65rem;
    text-align: center;
    font-family: PingFang-SC-Bold;
    background: url("../../static/images/hot_timebg.svg") center no-repeat;
    background-size: 100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/view/newshot.vue